import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/LanguageContext";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import MarqueeStrip from "@/components/site/MarqueeStrip";
import Mission from "@/components/site/Mission";
import WhatWeDo from "@/components/site/WhatWeDo";
import Expertise from "@/components/site/Expertise";
import OperatingModel from "@/components/site/OperatingModel";
import Proven from "@/components/site/Proven";
import Ecosystem from "@/components/site/Ecosystem";
import Group from "@/components/site/Group";
import Values from "@/components/site/Values";
import WhyMagis from "@/components/site/WhyMagis";
import Vision from "@/components/site/Vision";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import LegalPage from "@/components/site/LegalPage";

function Home() {
  return (
    <div className="grain relative bg-navy min-h-screen antialiased">
      <Navbar />
      <main>
        <Hero />
        <MarqueeStrip />
        <Mission />
        <WhatWeDo />
        <Expertise />
        <OperatingModel />
        <Proven />
        <Ecosystem />
        <Group />
        <Values />
        <WhyMagis />
        <Vision />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privacy" element={<LegalPage type="privacy" />} />
            <Route path="/legal" element={<LegalPage type="legal" />} />
          </Routes>
        </ReactLenis>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: { background: "#0F1A2C", color: "#F8FAFC", border: "1px solid rgba(212,175,55,0.35)" },
        }}
      />
    </LanguageProvider>
  );
}

export default App;
